import { createFileRoute } from '@tanstack/react-router'
import { ContractEditor } from './-ContractEditor'

// ModuleGuard komt van de contracts-route.tsx layout — geen wikkel per pagina.
export const Route = createFileRoute('/hr/contracts/$id')({
  component: ContractDetail,
})

function ContractDetail() {
  const { id } = Route.useParams()
  return <ContractEditor id={id} />
}
